import styled from 'styled-components'

const mobileBreakpoints = props => props.theme.mediaQuery.up('mobile-landscape')
const lastMileButtonStyles = '& button:not([disabled]) { background: #FF7C1F; color: white; } & button:not([disabled]):hover { background: #e06c18; }'

export const StyledContainer = styled.div`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 0; 
    height: 0;
  }
`

export const StyledH3 = styled.h3`
  color: #3E3E47;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
  margin: 0;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
`

export const StyledZipContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0px 0px 0px;
  gap: 5px;

  #submit{
    align-self: end;
  }

  ${mobileBreakpoints} {
    flex-direction: row;
    ${({ $isLastMile }) => $isLastMile && 'align-items: flex-end;'}
    gap: 16px;
  }
`

export const StyledSpacer = styled.div`
  height: 16px;
  width: 100%
`

export const StyledSubtitle = styled.div`
  color: #3E3E47;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 165%;

  & > small {
    font-size: 12px;
  }
`

export const StyledFormFieldContainer = styled.div`
  flex-grow: 1;
`

export const StyledFooter = styled.div`
  gap: 4px;
  margin: 12px 0px 0px 0px;
`

export const StyledFooterNote = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 165%;
  letter-spacing: 0em;
  text-align: left;
  color: #5E5E65;

  & > small {
    font-size: 10px;
  }
`

export const StyledLastMileUpdateButton = styled.div`
  ${({ $isLastMile }) => $isLastMile && lastMileButtonStyles}
`
